export default {
  name: 'Modal',
  props: {
    value: {
      required: true,
      type: Boolean,
    },
    backdrop: {
      default: true,
      type: Boolean,
    },
    interactiveBackdrop: {
      default: true,
      type: Boolean,
    },
    closeOnSubmit: {
      default: true,
      type: Boolean,
    },
    fullscreen: {
      default: false,
      type: Boolean,
    },
    title: {
      required: false,
      default: '',
      type: String,
    },
    hideButtons: {
      required: false,
      default: false,
      type: Boolean,
    },
    submitText: {
      required: false,
      default: '',
      type: String,
    },
    cancelText: {
      required: false,
      default: '',
      type: String,
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onEscPressed);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onEscPressed);
  },
  methods: {
    async onEscPressed($event) {
      if ($event && $event.key === 'Escape' && this.isOpen) {
        await this.onCancel();
      }
    },
    async closeModal() {
      this.$emit('input', false);
    },
    async onSubmit() {
      this.$emit('submit');
      if (this.closeOnSubmit) {
        await this.closeModal();
      }
    },
    async onCancel() {
      this.$emit('cancel');
      await this.closeModal();
    },
    async onBackdropClick() {
      if (this.interactiveBackdrop) {
        await this.onCancel();
      }
    }
  },
  computed: {
    openClasses() {
      if (this.isOpen) {
        return ['modal-active'];
      }
      return [];
    },
    fullscreenStyles() {
      if (this.fullscreen) {
        return [];
      }
      return [];
    },
    isOpen() {
      return this.value;
    },
  },
};
